module.exports = __webpack_public_path__ + "img/gb13.prt.3a4613e3.jpg";